<template>
  <Car :type="`4`" />
</template>

<script>
import Car from './index.vue'
export default {
  components: {
    Car
  }
}
</script>

<style lang="scss" scoped></style>
